import styled from "styled-components";
import { colors } from "styles/global-styles";

const PageWrap = styled.div`
    max-height: 2.25rem;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 0.25rem;
    .btn-paganation {
        padding: 0.5rem;
        border-radius: 0.25rem;
        background-color: ${({theme}) => theme.newTheme.default.secondary};
        color: ${({theme}) => theme.newTheme.default.accent};
        &:hover {
            background-color: ${colors.primaryHover};
            color: ${({theme}) => theme.newTheme.default.accent};
            cursor: pointer;
        }
        &.active {
            background-color: ${({theme}) => theme.newTheme.default.primary};
            color: ${({theme}) => theme.newTheme.default.accent};
        }
    }
    button {
        color: ${({theme}) => theme.newTheme.default.accent};
        &:disabled {
            cursor: auto;
        }
    }
`;

function Pagenation({ totalCount, total, limit, page, setPage, startButtonNum, setClickButton }:
    { totalCount: number, total: number, limit: number, page: number, startButtonNum: number, setPage: Function, setClickButton: Function }) {
    const buttonPerPage = limit; // 보여줄 페이지네이션 버튼 수
    const numPages = total; // 총 페이지 수
    
    // console.log(totalCount, page, limit);
    // DATA 수 가 해당 페이지의 수보다 적으면 1페이지로 이동
    totalCount <= ((page-1) * limit) && setPage(1);

    return (
        <PageWrap>
            {!numPages ? null : (
            <>
                {!(page <= buttonPerPage) && <button type="button" onClick={() => setClickButton('prev')} >이전</button>}
                {Array.from({ length: numPages > buttonPerPage? buttonPerPage : numPages }).map((_, i) => {
                    let pages = startButtonNum + i;
                    return (
                        (pages > numPages ? null : 
                            <p key={i} className={`btn-paganation ${page === pages ? 'active' : ''}`} onClick={() => setPage(pages)}>{pages}</p>
                        )
                    )
                })}
                {!(page === numPages || (numPages - startButtonNum) < buttonPerPage) && <button type="button" onClick={() => setClickButton('next')} >다음</button>}
            </>
            )}
        </PageWrap>
    );
}

export default Pagenation;